import React from 'react';
import { IMaskInput } from 'react-imask';
import styled from 'styled-components';
import InputStyles from './InputStyles';

interface IDOBInputProps {
  type?: string;
  disabled?: boolean;
  id?: string;
  placeholder?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: Event) => void;
  value?: string;
}

const StyledImaskInput = styled(IMaskInput).attrs({
  inputMode: 'numeric',
})`
  ${InputStyles}
`;

const DOBInput: React.FC<IDOBInputProps> = ({ onChange, ...props }) => {
  // onAccept, not onChange: React drops the event when the mask reformats an autofill value.
  const handleAccept = (_value: unknown, _mask: unknown, e?: InputEvent) => e && onChange?.(e);

  return <StyledImaskInput data-cy="date-of-birth-input" mask="00-00-0000" {...props} onAccept={handleAccept} />;
};

export default DOBInput;
